<script>
  function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
  }
</script>


<div class="card bg-emphasis bg-opacity-25">
  <div class="card-header fw-bold small text-truncate text-uppercase" *ngIf="widget.showTitle">
    <div class="d-flex">
      <span class="flex-grow-1 fw-bold small">
          {{widget.name}}
      </span>                    
      <span>
        <a class="button" (click)="refresh()">
          <i class="fa fa-refresh"></i>
        </a>
      </span>
    </div>
  </div>  
  <div class="card-body p-2" [className]="c ? c.cssClass : ''">
    <app-image-overlay [imageUrl]="imageUrl" [imageData]="imageData" [overlayConfig]=" c ? c.timeSeriesDetailList : null" [allowPointSelection]="false" 
      (objectSelected)="objectSelected($event);"></app-image-overlay>
  </div>
  
  <div class="card-arrow">
    <div class="card-arrow-top-left"></div>
    <div class="card-arrow-top-right"></div>
    <div class="card-arrow-bottom-left"></div>
    <div class="card-arrow-bottom-right"></div>
  </div>
</div>